export class CandidateInfo {
  public availabilityStatus: null | number = null;
  public candidateId: number = 0;
  public companyCode: null = null;
  public createdDttm: null = null;
  public displayName: string = '';
  public documentExtType: null = null;
  public email: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public phoneNumber: string = '';
  public profilePicExtType: null | string = null;
  public profilePicGuid: null | string = null;
  public updatedDttm: null = null;
  public userId: number = 0;
  public userName: null | string = null;
  public userProfileBasePath: null | string = null;
  public userRole: string = '';
}
